import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import { CompanyMethod } from '../../../../integrationsMarketplace/integrationsMarketplaceAppContainer/types/companies';

export class CompaniesForContainerImageScannerIntegrationsDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          page,
          limit,
          companyName: searchValue,
          options: {
            source: 'fromContainerImageScannerIntegration',
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: CompanyMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          page: 1,
          limit: DEFAULT_DATA_LIMIT,
          options: {
            source: 'fromContainerImageScannerIntegration',
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
